import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import type { MaintenanceStep } from './types'

type UseMaintenanceStepParams = {
    selectedId: string
    setSelectedId(value: string): void
}

type StartAnalysisStepOptions = {
    resetActiveSelection(): void
    focusTextarea(): void
}

type ReturnToAssessmentStepOptions = {
    resetActiveSelection(): void
    clearSubmissionFeedback(): void
}

/** 유지하기 화면의 단계 전환과 전환 시 필요한 선택 상태 초기화를 관리한다. */
export function useMaintenanceStep({
    selectedId,
    setSelectedId,
}: UseMaintenanceStepParams) {
    const [step, setStep] = useState<MaintenanceStep>('select-assessment')

    // 헤더 "유지하기" 재클릭 신호(location.state.maintenanceHome)를 받으면 1단계로 복귀한다(#15).
    // 같은 경로 재클릭은 페이지를 리마운트하지 않으므로 내부 단계를 명시적으로 되돌려야 한다.
    const location = useLocation()
    const homeSignal = (
        location.state as { maintenanceHome?: number } | null
    )?.maintenanceHome
    const seenSignal = useRef(homeSignal)
    useEffect(() => {
        if (homeSignal !== undefined && homeSignal !== seenSignal.current) {
            seenSignal.current = homeSignal
            setStep('select-assessment')
        }
    }, [homeSignal])

    const startAnalysisStep = (
        nextSelectedId = selectedId,
        options: StartAnalysisStepOptions
    ) => {
        if (!nextSelectedId) return
        setSelectedId(nextSelectedId)
        setStep('analyze-change')
        options.resetActiveSelection()
        window.setTimeout(options.focusTextarea, 0)
    }

    const returnToAssessmentStep = (options: ReturnToAssessmentStepOptions) => {
        setStep('select-assessment')
        options.resetActiveSelection()
        options.clearSubmissionFeedback()
    }

    return {
        step,
        startAnalysisStep,
        returnToAssessmentStep,
    }
}
